module.exports = __webpack_public_path__ + "static/img/image9.11ab095.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/image9.png
// module id = 03U2
// module chunks = 1